module.exports = __webpack_public_path__ + "img/try.d24b877a.png";